import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_qgdotrader.png",
      alt: "Estratégias QG do Trader",
    },
    title: "Opere com o QG INVESTING 2.0",

    // String ou array de strings
    text: "Com mais de 10 anos de experiência de mercado, o QG DO TRADER vem inovando na automação de estratégias por meio da inteligência artificial e programação. Nossas estratégias foram desenvolvidas e testadas por especialistas do mercado financeiro para que sejam executadas com a maior qualidade possível e seguindo os parâmetros de gestão de riscos, possibilitando sua alavancagem financeira de forma segura e sustentável.",
    testimonial: {
      text: "Buscamos a excelência através de estratégias que sejam eficazes e que tragam resultados reais para o seu capital.",
      author: {
        name: "Raphael B.M., Head de Estratégias e Professor no QG DO TRADER",
        // picture: 'https://ontick-img.s3.sa-east-1.amazonaws.com/raphael_qgdotrader_profile.png',
      },
    },
  },
  stats: {
    title: "Alguns números do QG INVESTING 2.0",
    subtitle:
      "Mais de 10 anos de experiência em mercado financeiro e automação de estratégias.",
    data: [
      {
        value: "+10 anos",
        description: "em atividade",
      },
      {
        value: "+5k",
        description: "clientes satisfeitos",
      },
      {
        value: "+10M",
        description: "ordens executadas por ano",
      },
    ],
  },
  features: {
    type: 1,
    title: "Por que utilizar os robôs do QG INVESTING 2.0?",
    subtitle: "Veja quais as principais vantagens em escolher os nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "30 dias para testar",
        description: "Confira a nossa performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% Automatizado",
        description:
          "Desfrute o mercado financeiro sem precisar tomar decisões. Os nossos robôs o farão por você.",
      },
      {
        icon: iconsSet.chat_round,
        title: "Suporte Individual",
        description:
          "Valorizamos o bom atendimento humanizado para tirar todas as dúvidas referentes aos nossos produtos e serviços.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos processam um número de informações muito maior que qualquer ser humano conseguiria de forma simultânea.",
      },
      {
        icon: iconsSet.clock,
        title: "Tempo",
        description:
          "Com os nossos robôs não será necessário acompanhar o mercado para tomada de decisões e com isso você terá mais tempo para realização de outras atividades.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem emocional",
        description:
          "As nossas estratégias irão permitir que você desfrute do mercado financeiro sem afetar o seu emocional, uma vez que não haverá o impulso ou decisões irracionais decorrentes do fator humano.",
      },
      // ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Vamos começar agora?",
    subtitle: "Faça agora mesmo a extensão QG INVESTING 2.0",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O QG do Trader",
    col1: [
      "Somos uma empresa desenvolvida inicialmente para oferecer conteúdo sobre o mercado financeiro de forma simples e objetiva, desmistificando a crença de que o mercado financeiro é “um bicho de sete cabeças”. Nossa instituição nasceu com o objetivo de ser uma escola de formação de operadores e se dedicou na última década a desenvolver estratégias automatizadas a partir das estratégias já ensinadas em sala de aula.",
      "Nossa missão é oferecer estratégias de ponta que sejam eficazes e seguras para serem executadas no mercado financeiro de forma 100% automatizada seguindo os parâmetros de gestão de riscos. Queremos, efetivamente, possibilitar a alavancagem financeira através da automatização de maneira segura e sustentável.",
    ],
    // col2: [
    //   "Queremos facilitar e pavimentar a boa gestão dos investimentos dos nossos clientes! Por isso, desenvolvemos alguns conceitos de robôs baseados em anos de estudos, experiência e milhares de testes positivos.",
    // ],
  },
  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos QG INVESTING 2.0 e veja qual se adequa melhor ao seu perfil.",
  },
  strategies: {
    title: "Estratégias QG INVESTING 2.0",
    heading: "Algoritmos avançados ao seu dispor.",
    subtitle:
      "Desfrute agora das melhores estratégias do mercado com apenas alguns cliques.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
